module.exports = ol.source.Image;